var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionMyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 2.33337C7.55992 2.33337 2.33325 7.56004 2.33325 14C2.33325 20.44 7.55992 25.6667 13.9999 25.6667C20.4399 25.6667 25.6666 20.44 25.6666 14C25.6666 7.56004 20.4399 2.33337 13.9999 2.33337ZM13.9999 5.83337C15.9366 5.83337 17.4999 7.39671 17.4999 9.33337C17.4999 11.27 15.9366 12.8334 13.9999 12.8334C12.0633 12.8334 10.4999 11.27 10.4999 9.33337C10.4999 7.39671 12.0633 5.83337 13.9999 5.83337ZM13.9999 22.4C11.0833 22.4 8.50492 20.9067 6.99992 18.6434C7.03492 16.3217 11.6666 15.05 13.9999 15.05C16.3216 15.05 20.9649 16.3217 20.9999 18.6434C19.4949 20.9067 16.9166 22.4 13.9999 22.4Z",
    fill: "#2BACE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionMyAccount);
export default __webpack_public_path__ + "static/media/action-my-account.b9c280bfba5ebf380d4d4342d11b0836.svg";
export { ForwardRef as ReactComponent };